import { Link } from "react-router-dom";

function ElectionInformationPage() {
  return (
    <main className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1
          className="text-5xl font-bold text-center mb-16 text-black"
          style={{ fontFamily: "Poppins, sans-serif" }}
        >
          2025 Local Elections – Key Dates
        </h1>

        <div className="space-y-10 mb-16">
          <div className="bg-white rounded-lg shadow-lg p-8 border-2 border-indigo-900">
            <h3 className="text-3xl font-bold text-indigo-900 mb-6">
              Voter Registration Deadline
            </h3>
            <p className="text-2xl text-gray-800">Monday, September 8 🗳️</p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 border-2 border-indigo-900">
            <h3 className="text-3xl font-bold text-indigo-900 mb-6">
              Early Voting
            </h3>
            <p className="text-2xl text-gray-800">October 20 – October 31</p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 border-2 border-indigo-900">
            <h3 className="text-3xl font-bold text-indigo-900 mb-6">
              Election Day
            </h3>
            <p className="text-2xl text-gray-800">Tuesday, November 4</p>
          </div>
        </div>

        <div className="text-center">
          <Link
            to="/donate"
            className="bg-black hover:bg-indigo-800 text-white text-2xl font-bold py-4 px-10 rounded-full shadow-lg transition"
          >
            INVEST IN VICTORY
          </Link>
        </div>
      </div>
    </main>
  );
}

export default ElectionInformationPage;
